/* External dependencies */
import { concat, from, of } from 'rxjs';
import { catchError, filter, switchMap } from 'rxjs/operators';

/* Local dependencies */
import { getClient } from '../../../../../clients/client';
import { updateUserForManagerError, updateUserForManagerSuccess } from './action';
import { updateUserForManagerMutation } from './mutation';
import { UpdateUserForManagerActionTypes, UpdateUserForManagerInput, UpdateUserForManagerRequest } from './types';

export default function updateUserForManagerEpic(action$, state$) {
  return action$.pipe(
    filter(
      (action: UpdateUserForManagerRequest) =>
        action.type === UpdateUserForManagerActionTypes.UPDATE_USER_FOR_MANAGER,
    ),
    switchMap((action: UpdateUserForManagerRequest) =>
      from(updateUserForManager(action.input)).pipe(
        switchMap(() => {
          return concat(
            from([updateUserForManagerSuccess()]),
          );
        }),
        catchError((error) => of(updateUserForManagerError(error))),
      ),
    ),
  );
}

export async function updateUserForManager(input: UpdateUserForManagerInput): Promise<void> {
  const graphQLClient = await getClient();

  const mutation = { mutation: updateUserForManagerMutation, variables: { input } };

  const {
    data: { updateUserForManager },
  } = await graphQLClient.mutate(mutation);

  return updateUserForManager;
}
